<template>
  <div class="container mx-auto p-6 lg:mt-6 max-w-3xl mx-auto">
    <router-link to="/" alt="OnlineRuler" title="OnlineRuler">
      <h1
        class="my-6 font-bold text-4xl lg:text-5xl bg-gradient-to-l from-blue-500 via-teal-500 to-green-500 text-transparent bg-clip-text"
      >
        📏 Online Ruler
      </h1>
    </router-link>
    <!-- Title -->
    <h1 class="text-2xl font-bold mb-6">About</h1>

    <!-- Introduction -->
    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">What is OnlineRuler?</h2>
      <p class="text-lg mb-3">
        Online Ruler is a digital tool designed to provide accurate measurements
        directly on your screen. Whether you're on a desktop, tablet, or mobile
        device, Online Ruler aims to give you precise inch and centimeter
        readings, allowing for quick and convenient measurements without the
        need for a physical ruler.
      </p>
    </section>

    <!-- Why Ruler App? -->
    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">Why Online Ruler?</h2>
      <p class="text-lg mb-3">
        In today's digital age, sometimes we find ourselves needing to measure
        something when we don't have a ruler at hand. Whether you're a designer
        needing to check the dimensions of an on-screen element, a DIY
        enthusiast wanting to double-check a measurement, or just someone
        curious about the size of objects, our Ruler App is here to assist.
      </p>
    </section>

    <!-- Key Features -->
    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">Key Features:</h2>
      <ul class="list-disc pl-6">
        <li class="text-lg mb-2">
          Adaptive Design: Our ruler adjusts based on your device's DPI,
          ensuring accurate measurements across different screens.
        </li>
        <li class="text-lg mb-2">
          Orientation Aware: On mobile devices, the ruler aligns vertically
          against the left side for easy measuring.
        </li>
        <li class="text-lg mb-2">
          Dual Unit Display: Get measurements in both inches and centimeters.
        </li>
      </ul>
    </section>

    <!-- How It Works -->
    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">How It Works:</h2>
      <p class="text-lg mb-3">
        Utilizing advanced calculations based on your device's DPI (dots per
        inch) and the devicePixelRatio, Online Ruler translates pixels into
        real-world units, ensuring that 1 inch on the ruler is as close to 1
        real-world inch as possible.
      </p>
    </section>

    <!-- Safety & Privacy -->
    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">Safety & Privacy:</h2>
      <p class="text-lg mb-3">
        Online Ruler is committed to ensuring the safety and privacy of its
        users. The application does not collect, store, or share any personal
        data. Your measurements and activities remain entirely on your device.
      </p>
    </section>
  </div>
</template>

<script>
</script>

<style>
.about {
  text-align: left;
  padding: 20px;
}
</style>